<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 移动端专用布局 -->
    <div class="flex flex-col h-screen">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
// 移动端布局配置
useHead({
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
    { name: 'format-detection', content: 'telephone=no' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
    { name: 'theme-color', content: '#ffffff' }
  ]
})

// 防止移动端双击缩放
onMounted(() => {
  let lastTouchEnd = 0
  document.addEventListener('touchend', (event) => {
    const now = (new Date()).getTime()
    if (now - lastTouchEnd <= 300) {
      event.preventDefault()
    }
    lastTouchEnd = now
  }, false)
  
  // 防止iOS Safari的橡皮筋效果，但允许正常滚动
  document.addEventListener('touchmove', (event) => {
    // 只在缩放时阻止，允许正常滚动
    if (event.scale && event.scale !== 1) {
      event.preventDefault()
    }
  }, { passive: false })
})
</script>

<style>
/* 移动端全局样式重置 */
html, body {
  height: 100%;
  -webkit-overflow-scrolling: touch;
}

/* 防止iOS Safari地址栏影响，但保持滚动能力 */
body {
  width: 100%;
  min-height: 100%;
}

/* 移动端触摸优化 */
* {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/* 允许滚动容器正常滚动 */
.overflow-y-auto, .overflow-x-auto {
  -webkit-user-select: auto;
  user-select: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

/* 允许输入框选择文本 */
input, textarea, [contenteditable] {
  -webkit-user-select: text;
  user-select: text;
}

/* 移动端按钮样式 */
button {
  -webkit-appearance: none;
  appearance: none;
  border: none;
  background: none;
  outline: none;
}

/* 移动端滚动条隐藏 */
::-webkit-scrollbar {
  display: none;
}

/* 支持安全区域 */
@supports (padding: max(0px)) {
  .safe-area-inset-top {
    padding-top: max(12px, env(safe-area-inset-top));
  }
  
  .safe-area-inset-bottom {
    padding-bottom: max(12px, env(safe-area-inset-bottom));
  }
  
  .safe-area-inset-left {
    padding-left: max(16px, env(safe-area-inset-left));
  }
  
  .safe-area-inset-right {
    padding-right: max(16px, env(safe-area-inset-right));
  }
}
</style>